module.exports = __webpack_public_path__ + "img/thumbs_up.7bd34552.svg";